import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { LoaderWrapper } from "app/components/no-touch-purchase-modal/summary-modal/loaders/StyledLoaders";

export const SelectorLoader = ({ isOneClickSmallTest }: { isOneClickSmallTest: boolean }) => {
    return (
        <LoaderWrapper>
            <PixelPlaceholderLoader
                width={274}
                height={22}
            />
            {!isOneClickSmallTest ? (
                <Flex
                    flexDirection="column"
                    gap="76px"
                >
                    <Flex
                        flexDirection="column"
                        gap="62px"
                    >
                        <PixelPlaceholderLoader
                            width={408}
                            height={22}
                        />

                        <Flex
                            flexDirection="column"
                            gap="36px"
                        >
                            <PixelPlaceholderLoader
                                width={185}
                                height={22}
                            />

                            <PixelPlaceholderLoader
                                width={365}
                                height={22}
                            />

                            <PixelPlaceholderLoader
                                width={365}
                                height={22}
                            />
                        </Flex>
                    </Flex>

                    <PixelPlaceholderLoader
                        width={337}
                        height={22}
                    />
                </Flex>
            ) : null}
        </LoaderWrapper>
    );
};
